// src/pages/QRCodePage.tsx
import * as React from 'react';

const INSTAGRAM_URL = 'https://www.instagram.com/antarestecnologiagta';

export default function QRCodePage() {
  return (
    <main
      className="min-h-screen flex flex-col items-center justify-center px-6 py-10 bg-brand-bg overflow-hidden relative"
    >
      {/* Blobs decorativos */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div
          className="absolute -top-32 -left-32 h-80 w-80 rounded-full blur-[100px] opacity-30"
          style={{ background: 'radial-gradient(circle,#E91E8C,transparent 60%)' }}
        />
        <div
          className="absolute -bottom-32 -right-32 h-80 w-80 rounded-full blur-[100px] opacity-25"
          style={{ background: 'radial-gradient(circle,#7C3AED,transparent 60%)' }}
        />
      </div>

      {/* Logo */}
      <div className="flex flex-col items-center gap-3 mb-8">
        <img
          src="/logov1.png"
          alt="Antares Tecnologia GTA"
          className="h-24 w-24 object-contain drop-shadow-[0_0_24px_rgba(233,30,140,0.5)]"
        />
        <div className="text-center">
          <p className="text-2xl font-extrabold tracking-tight text-white">Antares</p>
          <p className="text-sm font-semibold tracking-[0.2em] text-transparent bg-clip-text bg-gradient-to-r from-brand-primary to-brand-secondary uppercase">
            Tecnologia GTA
          </p>
        </div>
      </div>

      {/* Mensagem */}
      <p className="text-brand-muted text-center text-sm max-w-xs mb-8 leading-relaxed">
        Escaneie o QR Code abaixo e conheça nossas soluções no Instagram.
      </p>

      {/* QR Code */}
      <div className="relative">
        {/* Glow ring */}
        <div
          className="absolute inset-0 rounded-3xl blur-2xl opacity-40"
          style={{ background: 'linear-gradient(135deg,#E91E8C,#7C3AED)' }}
        />
        <div className="relative rounded-3xl border border-white/15 bg-white p-4 shadow-[0_20px_60px_rgba(0,0,0,0.5)]">
          <img
            src="/qr-code.png"
            alt="QR Code — Antares Tecnologia GTA no Instagram"
            className="h-64 w-64 object-contain rounded-xl"
          />
        </div>
      </div>

      {/* Botão de atalho */}
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-10 inline-flex items-center gap-2 rounded-xl px-6 py-3 font-semibold text-white bg-gradient-to-r from-brand-primary to-brand-secondary shadow-[0_0_24px_rgba(233,30,140,0.4)] hover:brightness-110 transition text-sm"
      >
        Acessar Instagram
      </a>

      {/* Rodapé */}
      <p className="mt-8 text-xs text-brand-muted text-center opacity-60">
        © {new Date().getFullYear()} Antares Tecnologia GTA
      </p>
    </main>
  );
}
